import ObjectTree from "./ObjectTree.vue";

import { pluginify } from "../../util";

export default pluginify(ObjectTree);
export { ObjectTree };
